import _defineProperty from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React from 'react';
import IconBase from './IconBase';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var Planet = function Planet(props) {
  return /*#__PURE__*/_jsxs(IconBase, _objectSpread(_objectSpread({
    viewBox: "0 0 24 24"
  }, props), {}, {
    children: [/*#__PURE__*/_jsx("path", {
      d: "M12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21Z",
      stroke: "currentColor",
      strokeWidth: "2",
      strokeLinejoin: "round"
    }), /*#__PURE__*/_jsx("rect", {
      x: "3.5",
      y: "8.5",
      width: "17",
      height: "1",
      stroke: "currentColor",
      strokeLinejoin: "round"
    }), /*#__PURE__*/_jsx("rect", {
      x: "3.5",
      y: "14.5",
      width: "17",
      height: "1",
      stroke: "currentColor",
      strokeLinejoin: "round"
    }), /*#__PURE__*/_jsx("path", {
      d: "M11.9999 3C11.9999 3 16 7.5 16 12C16 16.5 12 21 12 21",
      stroke: "currentColor",
      strokeWidth: "2",
      strokeLinejoin: "round"
    }), /*#__PURE__*/_jsx("path", {
      d: "M12.0001 3C12.0001 3 8 7.5 8 12C8 16.5 12 21 12 21",
      stroke: "currentColor",
      strokeWidth: "2",
      strokeLinejoin: "round"
    })]
  }));
};

export default Planet;